// extracted by mini-css-extract-plugin
export default {"container":"container--tS97x","markerAnimationScale":"markerAnimationScale--pyZm6"};